import { useTranslation } from 'react-i18next';
import { useFilterStore } from '../store/filter-store';
import { Switch } from '@/components/ui/Switch';
import type { ChargeSpeedType } from '../types/filter.types';

/**
 * Charge speed filter section
 */
export function ChargeSpeedFilter() {
  const { t } = useTranslation();
  const showSlow = useFilterStore((s) => s.showSlow);
  const showFast = useFilterStore((s) => s.showFast);
  const showUltraFast = useFilterStore((s) => s.showUltraFast);
  const toggleChargeSpeed = useFilterStore((s) => s.toggleChargeSpeed);

  const filters: Array<{ type: ChargeSpeedType; checked: boolean }> = [
    { type: 'slow', checked: showSlow },
    { type: 'fast', checked: showFast },
    { type: 'ultraFast', checked: showUltraFast },
  ];

  return (
    <div className="space-y-3 pt-3 pb-2">
      {filters.map(({ type, checked }) => (
        <Switch
          key={type}
          checked={checked}
          onCheckedChange={() => toggleChargeSpeed(type)}
          label={t(`filters.chargeSpeed.${type}`)}
        />
      ))}
    </div>
  );
}
